module.exports = __webpack_public_path__ + "img/37217-031.5649288f.jpg";